<template>
  <div :class="className" class="flex justify-center items-center">
    {{ labelOn }}
    <label class="toggle w-full mx-2">
      <input type="checkbox" :id="id" :disabled="disabled" v-model="content" @change="handleInput($event)">
      <span class="slider"></span>
    </label>
    {{ labelOff }}
  </div>
</template>

<script>

export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    labelOn: {
      type: String
    },
    labelOff: {
      type: String
    },
    id: {
      type: String
    },
    value: {
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    content () {
      return this.value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('toggleSwitch', this.id, this.content)
    }
  }
}
</script>

<style scoped>
.toggle {
  --width: 65px;
  --height: 2em;
  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
}

/* hiding checkbox */
.toggle input {
  display: none;
}

/* Creating slider */
.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  transition: all 0.4s ease-in-out;
  background-color: white;
}

.toggle .slider::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
  background: #51b62c;
}

.toggle input:checked + .slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
  background: #3490DC;
}
/* Adding slider effect */
.toggle input:disabled + .slider {
  background-color: white;
}
.toggle input:disabled + .slider::before {
  background: #ccc;
}

</style>
